import { TranslationKey } from "@/translations/translations";

export interface CaseStudy {
    title: TranslationKey;
    company: TranslationKey;
    challenge: TranslationKey;
    whatIDid: TranslationKey;
    impact: TranslationKey[];
    systemicIntervention?: TranslationKey;
    timeline?: TranslationKey;
    whatThisDemonstrates?: TranslationKey;
}

export interface WorkPhase {
    number: number;
    title: TranslationKey;
    description: TranslationKey;
}

export const consultingHero = {
    title: "Organizational Systems That Scale",
    subtitle: "Transform organizational structure from scaling bottleneck into competitive advantage - through systemic design, not reorganization theater."
};

export const caseStudies: CaseStudy[] = [
    {
        title: "caseStudy1.title",
        company: "caseStudy1.company",
        timeline: "caseStudy1.timeline",
        challenge: "caseStudy1.challenge",
        whatIDid: "caseStudy1.whatIDid",
        impact: [
            "caseStudy1.impact1",
            "caseStudy1.impact2",
            "caseStudy1.impact3"
        ]
    },
    {
        title: "caseStudy2.title",
        company: "caseStudy2.company",
        timeline: "caseStudy2.timeline",
        challenge: "caseStudy2.challenge",
        whatIDid: "caseStudy2.whatIDid",
        impact: [
            "caseStudy2.impact1",
            "caseStudy2.impact2",
            "caseStudy2.impact3",
            "caseStudy2.impact4"
        ],
        systemicIntervention: "caseStudy2.systemicIntervention"
    },
    {
        title: "caseStudy3.title",
        company: "caseStudy3.company",
        timeline: "caseStudy3.timeline",
        challenge: "caseStudy3.challenge",
        whatIDid: "caseStudy3.whatIDid",
        impact: [
            "caseStudy3.impact1",
            "caseStudy3.impact2",
            "caseStudy3.impact3",
            "caseStudy3.impact4"
        ]
    },
    {
        title: "caseStudy4.title",
        company: "caseStudy4.company",
        timeline: "caseStudy4.timeline",
        challenge: "caseStudy4.challenge",
        whatIDid: "caseStudy4.whatIDid",
        impact: [
            "caseStudy4.impact1",
            "caseStudy4.impact2",
            "caseStudy4.impact3"
        ]
    },
    {
        title: "caseStudy5.title",
        company: "caseStudy5.company",
        timeline: "caseStudy5.timeline",
        challenge: "caseStudy5.challenge",
        whatIDid: "caseStudy5.whatIDid",
        impact: [
            "caseStudy5.impact1",
            "caseStudy5.impact2",
            "caseStudy5.impact3"
        ]
    },
    {
        title: "caseStudy6.title",
        company: "caseStudy6.company",
        timeline: "caseStudy6.timeline",
        challenge: "caseStudy6.challenge",
        whatIDid: "caseStudy6.whatIDid",
        impact: [
            "caseStudy6.impact1",
            "caseStudy6.impact2",
            "caseStudy6.impact3"
        ]
    }
];

export const workPhases: WorkPhase[] = [
    {
        number: 1,
        title: "workPhase1.title",
        description: "workPhase1.description"
    },
    {
        number: 2,
        title: "workPhase2.title",
        description: "workPhase2.description"
    },
    {
        number: 3,
        title: "workPhase3.title",
        description: "workPhase3.description"
    },
    {
        number: 4,
        title: "workPhase4.title",
        description: "workPhase4.description"
    },
    {
        number: 5,
        title: "workPhase5.title",
        description: "workPhase5.description"
    }
];

export const ctaSection = {
    title: "Is Your Organization Efficient Enough?",
    description: "Whether you're optimizing for profitability, speed, or resilience, the right organizational design multiplies what your people can achieve. Let's discuss your specific challenge.",
    buttonText: "Schedule a Conversation"
};
